import {Button, Panel} from "react-bootstrap";
import React, {Component, useRef} from "react";
import {notify} from "../../components/common/Notification";

export default function ({connectionId, courtCode, caseNumber}) {
  const inputRef = useRef(null);

  const copyToClipBoard = (button) => {
    inputRef.current.select();
    document.execCommand("copy");
    notify.success('Link copied to clipboard');
  };

  return (
    <Panel>
      <Panel.Heading>
        <Panel.Title componentClass="h3">SharePoint Docket Embed Widget</Panel.Title>
      </Panel.Heading>

      <Panel.Body>
        <p>
          Copy/Paste this embed code into the SharePoint site for this case to utilize the CourtDrive docket for
          this case within SharePoint.
        </p>

        <input
          type='text'
          ref={inputRef}
          value={`<iframe src="https://app.courtdrive.com/rpc/integrations/connections/${connectionId}/sharepoint/case/${courtCode}/${caseNumber}/docket" width="800" height="400" />`}
          size="75"
          readOnly
        />

        <Button bsStyle='primary' onClick={copyToClipBoard}>Copy</Button>
      </Panel.Body>
    </Panel>
  );
}



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/SharePointDocketEmbedSettings.jsx